import * as actionTypes from '../actions/ActionTypes';
import { REHYDRATE } from 'redux-persist';

const initialCommonState = {
  flashCardDetailList: [],
  cardViewedIndex: 0,
  viewedcard: 0,
  listOfCards: [],
  viewedCardStatus: 0,
  hiddenCardStatus: 0,
  totalCards: null,
};

const FlashCardReducer = (state = { ...initialCommonState }, action) => {
  switch (action.type) {
    case actionTypes.LIST_OF_CARDS:
      return {
        ...state,
        listOfCards: action.cards,
      };

    case actionTypes.UPDATE_FLASHCARD:
      let flashCardOldArray = state.flashCardDetailList;
      let flashCardNewArray = action.flashCardDetailArray;
      let completeFlashCardArray = arrayUnique(
        flashCardOldArray.concat(flashCardNewArray),
      );
      return {
        ...state,
        flashCardDetailList: completeFlashCardArray,
      };

    case actionTypes.VIEWCARD:
      return {
        ...state,
        viewedcard: action.viewcard,
      };
    case actionTypes.RESET_FLASHCARD:
      return {
        ...state,
        flashCardDetailList: action.resetFlashCardArray,
      };

    case actionTypes.FLASHCARD_COUNT:
      return {
        ...state,
        totalCards: action.totalCards,
      };

    case actionTypes.FLASHCARD_INDEX: {
      return {
        ...state,
        cardViewedIndex: action.cardIndex,
      };
    }

    case actionTypes.FLASHCARD_VIEWED_HIDDEN_STATUS:
      return {
        ...state,
        CardStatus: action.flashcard_viewed_hidden_status,
      };

    case actionTypes.LOGOUT:
      return { ...initialCommonState };

    case actionTypes.LOADING_CARDS:
      return {
        ...state,
        loading: action.loading || false,
      };

    case REHYDRATE:
      return {
        ...state,
        ...((action.payload || {}).FlashCardReducer || {}),
      };

    default:
      return state;

  }
};

function arrayUnique(flashCardArray) {
  let finalArray = [];
  for (let i = 0; i < flashCardArray.length; i++) {
    if (
      flashCardArray[i].flashcardId !== undefined &&
      flashCardArray[i].flashcardId !== null
    ) {
      finalArray[flashCardArray[i].flashcardId] = flashCardArray[i];
    }
  }

  let returnArray = [];
  for (let x of finalArray) {
    if (x != null) {
      returnArray.push(x);
    }
  }
  return returnArray;
}

export default FlashCardReducer;
